import { Person } from "components/LetsTalk/person"
import * as React from "react"
import * as styles from "./styles.module.scss"
import AboutBetter from "components/Tesla/AboutBetter"
import betterEmployee01_1080w from "./img/better-employee-01-1080w.jpg"
import betterEmployee01_540w from "./img/better-employee-01-540w.jpg"
import CallToAction from "components/Tesla/CallToAction"
import Document from "components/Document"
import Footer from "components/Footer"
import Glossary from "components/Tesla/Glossary"
import Hero from "components/Tesla/Hero"
import Lead from "components/Tesla/Lead"
import LetsTalk from "components/LetsTalk"
import LinkUnderline from "components/LinkUnderline"
import Navbar from "components/Navbar"
import { GetStartedType } from "components/Navbar/GetStartedButton"
import PageWrapper from "components/PageWrapper"
import RoofCalculator from "components/Tesla/RoofCalculator"
import Superscript from "components/Superscript"
import teslaPowerwall_1080w from "./img/tesla-powerwall-1080w.jpg"
import teslaPowerwall_540w from "./img/tesla-powerwall-540w.jpg"
import teslaSolarRoof1_1080w from "./img/tesla-solar-roof-1-1080w.jpg"
import teslaSolarRoof1_540w from "./img/tesla-solar-roof-1-540w.jpg"
import teslaSolarRoof2_1080w from "./img/tesla-solar-roof-2-1080w.jpg"
import teslaSolarRoof2_540w from "./img/tesla-solar-roof-2-540w.jpg"
import TextImageBlock from "components/TextImageBlock"
import Timeline from "components/Tesla/Timeline"
import { LetsTalkName } from "components/LetsTalk/types"

const Tesla: React.FC = () => {
  const letsTalkButton = {
    text: "Schedule your free call",
    url: "https://charlie-better.youcanbook.me/",
  }

  const subhead1 = () => {
    return (
      <>
        Simply put, the Solar Mortgage
        <Superscript>TM</Superscript> is a fully online cash out refinance. Even
        better, we use the expected increase in the value of your home and
        energy savings to qualify you for the lowest rates possible. Our credit
        application only takes three minutes—{" "}
        <a
          className={styles.link}
          href="https://www.better.com/api/leads?lead[sourceName]=Tesla"
          target="_self"
        >
          <LinkUnderline>find out how much you qualify for today</LinkUnderline>
        </a>
        .
      </>
    )
  }

  const subhead2 = () => {
    return (
      <>
        Better has developed a unique, customized mortgage product for solar
        installations. Rates for a Solar Mortgage<Superscript>TM</Superscript>{" "}
        are tax deductible and range from 3-5%, as opposed to 9-12% with
        traditional financing options like personal loans.
      </>
    )
  }

  const subhead4 = () => {
    return (
      <>
        The Solar Mortgage<Superscript>TM</Superscript> works for all Tesla
        customers, with or without current mortgages, with FICO scores as low as
        a 620. It can even finance additional products that help you enjoy the
        benefits of solar, including the Powerwall home battery.
      </>
    )
  }
  return (
    <Document
      brandMetaPrefix={true}
      description="Better is a direct lender dedicated to providing a fast, transparent, and online mortgage experience backed by superior customer support."
      keywords="home loans,mortgage interest rates,refinance rates,refinance calculator,refinance mortgage online"
      pageClass="bet-StaticPage"
      pageId="homepage"
      title="Simple, Online Mortgage"
    >
      <Navbar
        getStartedType={GetStartedType.ON_SCROLL}
        startWhite={true}
        getStartedLink="/start"
        startTransparent={true}
        hideLinks={true}
        logoLink="/partners/tesla"
        hideHamburger={true}
      />
      <PageWrapper>
        <main>
          <Hero hasTeslaLogo={true} />
          <Lead />
          <RoofCalculator />
          <TextImageBlock
            picturePosition="left"
            eyebrow="What it is"
            heading="A mortgage that does more"
            subhead={subhead1()}
            imgSrcLarge={teslaSolarRoof1_1080w}
            imgSrcLargeWidth="1080w"
            imgSrcSmall={teslaSolarRoof1_540w}
            imgSrcSmallWidth="540w"
            imgAlt="Tesla Solar Roof"
          ></TextImageBlock>
          <TextImageBlock
            picturePosition="right"
            eyebrow="How it works"
            heading="Get the benefits of a Solar Roof before it’s installed101"
            subhead={subhead2()}
            imgSrcLarge={teslaSolarRoof2_1080w}
            imgSrcLargeWidth="1080w"
            imgSrcSmall={teslaSolarRoof2_540w}
            imgSrcSmallWidth="540w"
            imgAlt="Tesla Solar Roof"
          />
          <TextImageBlock
            picturePosition="left"
            heading="A team of experts dedicated to your success"
            subhead="Our Tesla-trained non-commissioned sales, support and processing teams guide you through the process. We take care of everything, from providing the best possible rate to paying Tesla on your behalf. Our pre-approval, application, and lock can be all be completed online or by phone in as little as 15 minutes."
            imgSrcLarge={betterEmployee01_1080w}
            imgSrcLargeWidth="1080w"
            imgSrcSmall={betterEmployee01_540w}
            imgSrcSmallWidth="540w"
            imgAlt="Better employee"
          />
          <TextImageBlock
            picturePosition="right"
            eyebrow="Who it’s for"
            heading="Financing designed to fit your needs"
            subhead={subhead4()}
            imgSrcLarge={teslaPowerwall_1080w}
            imgSrcLargeWidth="1080w"
            imgSrcSmall={teslaPowerwall_540w}
            imgSrcSmallWidth="540w"
            imgAlt="Tesla Powerwall"
          />
          <Timeline />
          <div className={styles.aboutBetter}>
            <AboutBetter />
            <LetsTalk
              heading="Hi, I’m Charlie"
              headingMaxWidth={10}
              subhead="I’m one of the Better Mortgage Loan Consultants dedicated to helping Tesla customers refinance their Solar Roofs. My team is available at your convenience over text, email or phone. Let’s talk."
              nmlsCode="1667158"
              button={letsTalkButton}
              name={LetsTalkName.Charlie}
            />
          </div>
          <CallToAction />
        </main>
        <Glossary />
        <Footer loanType="tesla" />
      </PageWrapper>
    </Document>
  )
}

export default Tesla
